import { BaseService } from "./common/base";

export class AdminService extends BaseService {
  constructor() {
    super("admin");
  }

  getAppointmentStatistics(params: {
    periodStartDate: Date;
    periodEndDate: Date;
  }) {
    return this._get("/appointments/statistics", {
      params,
    });
  }

  findAppointments(params?: { first?: number; offset?: number }) {
    return this._get("/appointments", {
      params,
    });
  }

  findSupplyRequests() {
    return this._get("supply-requests");
  }

  getSupplyRequests(id: string) {
    return this._get(`supply-requests/${id}`);
  }
}
